import React, { createContext, useState, useCallback } from "react";
import OrganisationService from "../services/OrganisationService";

export const OrganisationContext = createContext(null);

export const OrganisationProvider = ({ children }) => {
  const [organisation, setOrganisation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [forbidden, setForbidden] = useState(false);

  const fetchOrganisation = useCallback(async (id, silent = false) => {
    setLoading(!silent);
    try {
      const data = await OrganisationService.getOrganisation(id);
      setOrganisation(data);
      setForbidden(false);
    } catch (error) {
      console.error("Error fetching organisation", error);
      setForbidden(error.response?.status === 403);
    } finally {
      setLoading(false);
    }
  }, []);

  const patchOrganisation = useCallback(async (id, payload) => {
    try {
      if (payload.logoFile) {
        await OrganisationService.updateLogo(id, payload.logoFile);
        delete payload.logoFile;
      }
      const data = await OrganisationService.patchOrganisation(id, payload);
      fetchOrganisation(id, true);
      return data;
    } catch (error) {
      console.error("Error updating organisation", error);
      throw error;
    }
  }, []);

  return (
    <OrganisationContext.Provider
      value={{
        organisation,
        loading,
        forbidden,
        fetchOrganisation,
        patchOrganisation,
      }}
    >
      {children}
    </OrganisationContext.Provider>
  );
};
